<template>
  <div
    :class="[
      'discovery-box-rate',
      { 'discovery-box-rate--positive': isPositive },
    ]"
  >
    <p class="discovery-box-rate__title">{{ label }}</p>

    <dl>
      <div class="discovery-box-rate__row">
        <dt>
          {{ $t('YOU') }}
        </dt>

        <dd class="discovery-box-rate__value">
          {{ formattedValue }}

          <i :class="`el-icon-arrow-${isPositive ? 'up' : 'down'}`" />
        </dd>
      </div>

      <div class="discovery-box-rate__row">
        <dt>
          {{ $t('AVERAGE') }}
        </dt>
        <dd>
          {{ formattedAverage }}
        </dd>
      </div>
    </dl>
  </div>
</template>

<script>
function formatPercentage(val) {
  if (!val) {
    return '0';
  }

  return `${Number(val.toFixed(4))}%`;
}

export default {
  name: 'DiscoveryBoxRate',

  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: Number,
      required: true,
    },
    average: {
      type: Number,
      required: true,
    },
  },

  computed: {
    isPositive() {
      return this.value >= this.average;
    },
    formattedValue() {
      return formatPercentage(this.value * 100);
    },
    formattedAverage() {
      return formatPercentage(this.average * 100);
    },
  },
};
</script>

<style lang="scss">
.discovery-box-rate {
  width: 100%;
  background-color: #fff;

  border: 1px solid $lb-light-gray;
  border-radius: $lb-border-radius * 5;
  padding: $global-padding * 1.5;

  &__row {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__title {
    font-size: rem-calc(14px);
  }

  dd {
    font-size: rem-calc(20px);
    font-weight: 400;
  }

  dt {
    font-weight: 400;
    color: $lb-light-black;
  }

  &__value {
    font-weight: 700 !important;
    color: #f56c6c;
  }

  &--positive {
    .discovery-box-rate__value {
      color: #0ea960;
    }
  }
}
</style>
